// extracted by mini-css-extract-plugin
export var popup = "GameConceptFilterPopup-module__popup___Vt4M4";
export var radioLabel = "GameConceptFilterPopup-module__radioLabel___pprVv";
export var radioLabelSelected = "GameConceptFilterPopup-module__radioLabelSelected___ouPFU";
export var viewTitle = "GameConceptFilterPopup-module__viewTitle___jVraz";
export var xboxGreen = "#107C10";